import {ItemPedido} from "./ItemPedido";
import {Entrega} from "./Entrega";
import {Pagamento} from "./Pagamento";
import {CupomPedido} from "./CupomPedido";
import {IUITipoPontuacaoFactory} from "./IUITipoPontuacaoFactory";
import {ObjetoComAdicionais} from "./ObjetoComAdicionais";
import {TaxaCobranca} from "./TaxaCobranca";
import {DescontoPromocional} from "./DescontoPromocional";
import {FormaDeEntrega} from "./FormaDeEntrega";
import {DataHoraUtils} from "../../../../src/app/lib/DataHoraUtils";

declare let moment;

export class PedidoLoja extends ObjetoComAdicionais {
  itens = [];
  total = 0.0;
  totalResgatado = 0;
  subTotal = 0.0;
  qtde = 0;
  entrega: Entrega;
  troco: number;
  novosEnderecos = [];
  pagamento: Pagamento;
  contato: any;
  codigo: string;
  guid: string;
  mesa: any;
  pago: boolean;
  dataEntrega: Date
  horarioEntrega: String
  pagarDepois = false;
  gerarLinkPagamento: boolean
  linkPagamento: string
  cupom: CupomPedido;
  promocoesAplicadas: DescontoPromocional[] = []
  desconto: number;
  descontoFormaDeEntrega: number;
  descontoFormaDePagamento: number;
  descricaoDescontoFormaDeEntrega: string;
  taxaFormaDePagamento: number;
  formasDeEntregaContexto: any[] = [];
  timestamp: any
  codigoCupom: string;
  pontosReceber: number;
  cashback;
  resgate: any;
  adicionais: any;
  camposAdicionais: any;
  disparouEventoIniciarCheckout = false;
  disparouEventoAddedToCart = false;
  itensPorEmpresa: any = {};
  fidelidadeGcom: any;
  acumulo: string;
  idComanda: number;
  idCartaoCliente: number;
  comandaValidada: any;
  tokenCartaoPendente: string;
  codigoCartaoPendente: string;
  tabelasDePrecosAplicadas: number[] = [];
  erroAoAdicionarItem: string = null;
  constructor(public origem: string  = null, contato: any = null, mesa: any = null) {
    super();
    this.entrega = new Entrega();
    this.pagamento = new Pagamento();
    this.mesa = mesa;
    this.setContato( contato || {})
  }

  setContato(contato: any){
    this.contato = contato;
    if(this.contato.dataNascimento)
      this.contato.dataNascimento = DataHoraUtils.obtenhaDataDaString(this.contato.dataNascimento);
  }

  atualizeFormasDeEntregaContexto(formasDeEntrega: any[] = []){
    this.formasDeEntregaContexto = formasDeEntrega || [];
  }

  private novoItem(produto: any, qtde: number, observacao: string, adicionais: any, tamanho: any , sabores: any){
    const itemPedido = new ItemPedido(produto, qtde, observacao);

    itemPedido.adicionais = adicionais
    itemPedido.produtoTamanho = tamanho
    itemPedido.sabores = sabores || []
    itemPedido.atualizeTotal();

    this.itens.push(itemPedido);
  }

  adicione(produto: any, qtde: number, observacao: string, adicionais: any, tamanho: any , sabores: any, ignorarLimiteProduto = false) {
    this.erroAoAdicionarItem = null;

    if(!produto) {
      this.erroAoAdicionarItem = 'Produto inválido para adicionar ao carrinho.';
      return null;
    }

    if(!ignorarLimiteProduto && !this.podeAdicionarQuantidadeProduto(produto, qtde)) {
      return null;
    }

    if(this.separarNoCarrinho(qtde, adicionais)){
      for(let i  = 1; i <= qtde; i++){
        let copiaAdicionais = JSON.parse(JSON.stringify(adicionais));
        if(i > 1)
          this.removaAdicionaisFixos(copiaAdicionais);
        this.novoItem(produto, 1, observacao, copiaAdicionais, tamanho, sabores)
      }
    } else {
      this.novoItem(produto, qtde, observacao, adicionais, tamanho, sabores)
    }

    this.limpeTroco();
    this.calculeTotal();
    this.atualizeTabelasDePrecosAplicadas();

    this.itensPorEmpresa = Object.values(this.calculeItensPorEmpresa());

    if(produto.brinde && produto.cupom){
      this.cupom = produto.cupom;
      this.cupom.aplicarAuto = this.cupom.brindeResgate = true;
    }

  }

  separarNoCarrinho(qtde: number, adicionais: any){
    if(adicionais && Object.keys(adicionais).length && qtde > 1){
      for(let key of Object.keys(adicionais)){
        if(key.startsWith('lista') && adicionais[key].totalSelecionado){
          return true;
        }
      }
    }

    return false;
  }

  private removaAdicionaisFixos(adicionais: any = {}){
    Object.keys(adicionais || {}).forEach((key: string) => {
      if(key.startsWith('campo') && adicionais[key] != null){
        const metaCampo = adicionais['meta_' + key];
        if(metaCampo && metaCampo.multiplicaQuantidadeProduto === false){
          delete adicionais[key];
          delete adicionais['escolhido_' + key];
          delete adicionais['meta_' + key];
        }
      }

      if(key.startsWith('lista') && adicionais[key] && adicionais[key].multiplicaQuantidadeProduto === false){
        delete adicionais[key];
      }
    });
  }

  private podeAdicionarQuantidadeProduto(produto: any, qtde: number, itemIgnorado: any = null) {
    this.erroAoAdicionarItem = null;

    const qtdMaxima = this.obtenhaQuantidadeMaximaDoProduto(produto);
    if(qtdMaxima == null) return true;

    const totalAtual = this.obtenhaQuantidadeAtualNoCarrinho(produto, itemIgnorado);
    const totalComNovoItem = totalAtual + Number(qtde || 0);

    if(totalComNovoItem <= qtdMaxima) return true;

    this.erroAoAdicionarItem = `Você não pode selecionar mais do que ${qtdMaxima} '${produto.nome}' por pedido.`;
    return false;
  }

  obtenhaErroAoAdicionarItem() {
    return this.erroAoAdicionarItem;
  }

  private obtenhaQuantidadeAtualNoCarrinho(produto: any, itemIgnorado: any = null) {
    let total = 0;
    for(const item of this.itens) {
      if(item === itemIgnorado) continue;
      if(item?.produto && item?.produto?.id != null && produto && produto.id != null && item.produto.id == produto.id)
        total += Number(item.qtde || 0);
    }
    return total;
  }

  private obtenhaQuantidadeMaximaDoProduto(produto: any) {
    if(produto?.qtdMaxima == null || produto.qtdMaxima === '')
      return null;

    const qtdMaxima = Number(produto.qtdMaxima);
    return Number.isFinite(qtdMaxima) && qtdMaxima > 0 ? qtdMaxima : null;
  }

  edite(indiceItem: any, produto: any, qtde: number, observacao: string, adicionais: any, tamanho: any , sabores: any) {
    this.erroAoAdicionarItem = null;

    if(this.separarNoCarrinho(qtde, adicionais)){
      if(!this.podeAdicionarQuantidadeProduto(produto, qtde, this.itens[indiceItem])) {
        return null;
      }

      this.removaItem(this.itens[indiceItem], indiceItem);
      return this.adicione(produto, qtde, observacao, adicionais, tamanho, sabores);
    } else {
      if(!this.podeAdicionarQuantidadeProduto(produto, qtde, this.itens[indiceItem])) {
        return null;
      }

      let itemExistente: ItemPedido = this.itens[indiceItem]
      itemExistente.atualize(qtde, observacao, adicionais, tamanho , sabores);
      this.limpeTroco();
      this.calculeTotal();
      this.atualizeTabelasDePrecosAplicadas();
      return itemExistente;
    }
  }

  limpeTroco(){
    if(this.pagamento) this.pagamento.trocoPara = 0;
  }

  expirou(){
    if(!this.timestamp) return true;
    let tempoMinutos =  (new Date().getTime() - this.timestamp) / 1000 / 60;

    return tempoMinutos >  240 ; //4h
  }

  estaEmFluxoMesa(): boolean {
    return !!this.mesa || !!this.tokenCartaoPendente;
  }



  calculeItensPorEmpresa() {
    let mapGrupos = {};

    for( let itemProduto of this.itens ) {
      const empresa = itemProduto.produto.empresa;

      if( !mapGrupos[empresa.id] ) {
        mapGrupos[empresa.id] = {
          empresa: empresa,
          itens: []
        };
      }

      mapGrupos[empresa.id].itens.push(itemProduto);
    }

    return mapGrupos
  }

  obtenhaTotalPontos(){
    let  totalEmPontos = 0;
    this.itens.forEach( ( itemPedido: any) => {
      if(itemPedido.brinde){
        totalEmPontos += itemPedido.valorResgatado;
        this.acumulo = itemPedido.produto.acumulo;
      }

    });

    return  Number(totalEmPontos.toFixed(2));
  }
  obtenhaSubTotal() {
    let subTotal = 0.0;

    this.itens.forEach( ( itemPedido: any) => {
      if(!itemPedido.brinde)
        subTotal += itemPedido.obtenhaValor();

    });

    return  Number(subTotal.toFixed(2));
  }

  obtenhaValorAhPagar() {
    let valor = this.total;

    if(this.cashback)
      valor -= this.cashback.valor;

    return Number(valor.toFixed(2));
  }


  obtenhaTotalSemTaxaEntrega(){
    let subtotal = this.obtenhaSubTotal();

    if(this.desconto)
      if(!this.cupom || !this.cupom.aplicarNaTaxaDeEntrega)
        subtotal -= this.desconto;

    if(this.descontoFormaDeEntrega)
      subtotal -= this.descontoFormaDeEntrega;

    if(this.descontoFormaDePagamento)
      subtotal -= this.descontoFormaDePagamento

    return subtotal;

  }

  private obtenhaValorPagoQuePontua() {
    if(this.cupom && this.cupom.naoPontuarFidelidade) return 0;

    let subtotal = this.obtenhaTotalSemTaxaEntrega();

    if(this.cashback && this.cashback.valor)
      subtotal = subtotal - this.cashback.valor;

    if(subtotal < 0)
      subtotal = 0

    return subtotal;
  }

  atualizeTotal() {
    this.configureAdicionais();

    const totalAntes: number = this.obtenhaValorAhPagar();

    this.calculeTotal();

    if(totalAntes !==  this.obtenhaValorAhPagar())
      this.removaPagamentoSelecionado();
  }

  removaPagamentoSelecionado(){
    if(this.pagamento) this.pagamento.limpePagamento();
  }

  calculeTotal(){
    this.atualizeQuantidadesParaPrecoAtacado();
    this.qtde = this.itens.length;
    this.subTotal = this.obtenhaSubTotal();
    this.total = this.subTotal;

    this.total +=  this.obtenhaValorAdicionais();
    this.totalResgatado  = this.obtenhaTotalPontos();

    if(this.desconto)
      this.total -= this.desconto;

    this.descontoFormaDeEntrega = 0;
    this.descricaoDescontoFormaDeEntrega = null;
    const descontoFormaDeEntrega = this.obtenhaDescontoFormaDeEntrega();
    if(descontoFormaDeEntrega > 0) {
      this.descontoFormaDeEntrega = descontoFormaDeEntrega;
      this.total -= this.descontoFormaDeEntrega;
    }

    this.descontoFormaDePagamento = null;

    if(this.pagamento.formaDePagamento){

      if(this.pagamento.formaDePagamento.possuiDesconto) {
        let total = this.total;

        if(this.cashback && this.cashback.podeUsarNoPedido)
          total = this.total - this.cashback.valor

        this.descontoFormaDePagamento = Number((total * this.pagamento.formaDePagamento.desconto / 100).toFixed(2));
        this.total -= this.descontoFormaDePagamento;
      }
    }

    if( this.entrega && this.entrega.taxaDeEntrega && this.entrega.taxaDeEntrega > 0 )
      this.total += this.obtenhaValorTaxaEntrega()


    if(this.pagamento.formaDePagamento && this.pagamento.formaDePagamento.taxaCobranca){
      this.taxaFormaDePagamento = TaxaCobranca.calcule(this.pagamento.formaDePagamento.taxaCobranca, this.obtenhaValorAhPagar())
      this.total +=    this.taxaFormaDePagamento;
    } else {
      this.taxaFormaDePagamento  = 0;
    }

    this.calculeTroco();
  }

  private atualizeQuantidadesParaPrecoAtacado() {
    const quantidadesPorAlvo: any = {};

    (this.itens || []).forEach((item: any) => {
      const chave = this.obtenhaChavePrecoAtacado(item);
      if(!chave) return;
      quantidadesPorAlvo[chave] = Number(quantidadesPorAlvo[chave] || 0) + Number(item.qtde || 0);
    });

    (this.itens || []).forEach((item: any) => {
      const chave = this.obtenhaChavePrecoAtacado(item);
      item.quantidadeParaPrecoAtacado = chave ? quantidadesPorAlvo[chave] : Number(item.qtde || 0);
      item.atualizeTotal();
    });
  }

  private obtenhaChavePrecoAtacado(item: any): string {
    if(!item?.produto?.id)
      return null;

    const tamanho = item.produtoTamanho;
    const tamanhoId = tamanho?.id || tamanho?.template?.id || '';
    return `${item.produto.id}:${tamanhoId}`;
  }

  private obtenhaDescontoFormaDeEntrega() {
    if(this.mesa) return 0;
    const formaEscolhida = this.obtenhaFormaEscolhida(this.formasDeEntregaContexto);
    if(!formaEscolhida || !this.entrega || !this.entrega.formaDeEntrega) return 0;

    const percentual = this.obtenhaPercentualDescontoForma(formaEscolhida);
    if(percentual <= 0) return 0;

    this.descricaoDescontoFormaDeEntrega = this.obtenhaDescricaoDescontoForma(this.entrega.formaDeEntrega);
    return Number((this.total * percentual / 100).toFixed(2));
  }

  private obtenhaPercentualDescontoForma(formaEscolhida: any) {
    const comerNoLocal = this.entrega && this.entrega.formaDeEntrega === FormaDeEntrega.COMERNOLOCAL;

    if(comerNoLocal){
      if(!formaEscolhida.permiteComerNoLocal || !formaEscolhida.possuiDescontoComerNoLocal) return 0;
      return Number(formaEscolhida.descontoPercentualComerNoLocal || 0);
    }

    if(!formaEscolhida.possuiDesconto) return 0;
    return Number(formaEscolhida.descontoPercentual || 0);
  }

  private obtenhaDescricaoDescontoForma(formaDeEntrega: any) {
    if(formaDeEntrega === FormaDeEntrega.COMERNOLOCAL) return 'Desconto Comer no local';
    if(formaDeEntrega === FormaDeEntrega.RECEBER_EM_CASA) return 'Desconto Entrega';
    return 'Desconto Retirada';
  }

  obtenhaValorParaValidacaoFormaEntrega(formasDeEntrega: any) {
    let valor = this.obtenhaTotalSemTaxaEntrega();

    if(this.descontoFormaDeEntrega){
      let formaDeEntrega = this.obtenhaFormaEscolhida(formasDeEntrega, this.entrega.formaDeEntrega);
      if(formaDeEntrega)
        valor += this.descontoFormaDeEntrega;
    }

    return Number(valor.toFixed(2));
  }

  obtenhaValorTaxaEntrega(){
    if(!this.entrega) return 0;

    if(this.entrega.valorComRetorno)
      if(!this.pagamento  ||  !this.pagamento.formaDePagamento  || this.pagamento.formaDePagamento.cobrarTaxaRetorno)
        return this.entrega.valorComRetorno

    return this.entrega.taxaDeEntrega
  }

  removaItem(item: any,  index = null) {
    if(!index) index = this.itens.indexOf(item);

    this.itens.splice(index, 1);

    if(item.produto && item.produto.cupom)
      if(this.cupom && this.cupom.id === item.produto.cupom)
        this.removaCupom();

    this.limpeTroco();
    this.calculeTotal();
    this.atualizeTabelasDePrecosAplicadas();

    this.itensPorEmpresa = Object.values(this.calculeItensPorEmpresa())
  }

  obtenhaDescricaoPromocoes() {
    if(!this.promocoesAplicadas) return null

    return this.promocoesAplicadas.map((promocaoAplicada) => promocaoAplicada.descricao ).join(",")
  }

  getItem(produto: any): ItemPedido{
    return this.itens.find( item => item.produto.id === produto.id)
  }

  calculeTroco() {
    this.troco = 0;

    if (this.pagamento && this.pagamento.trocoPara)
      this.troco = this.pagamento.trocoPara - this.total

    if (this.troco < 0)
      this.troco = 0;

  }


  calculePontosAhReceber(empresa: any, integracao: any) {
    if (integracao.pontuando) {

      if(!this.mesa || integracao.pontuarMesas){
        if(this.cupom && this.cupom.cashback)
          integracao.atividade.cashback = this.cupom.cashback

        this.pontosReceber =
          IUITipoPontuacaoFactory.crie(empresa, integracao).obtenhaPontosFormatado(this.obtenhaValorPagoQuePontua(), this.itens);
      }
    }

  }

  obtenhaDadosEnvio(empresa: any) {
    let horarioEntrega = this.obtenhaHorarioEntregaAgendada(empresa)
    this.atualizeTabelasDePrecosAplicadas();

    let dados: any = {
      contato: this.contato,
      itens: this.itens,
      mesa: this.mesa,
      guid: this.guid,
      cupom: this.cupom,
      promocoesAplicadas: this.promocoesAplicadas,
      codigo: this.codigo,
      pagamentos: [],
      horarioEntregaAgendada: horarioEntrega,
      textoHorarioEntregaAgendada: horarioEntrega ? horarioEntrega.toLocaleString("pt-BR") : null,
      formaDeEntrega: this.entrega.obtenhaForma(),
      taxaEntrega: this.obtenhaValorTaxaEntrega(),
      taxaCalculadaId: this.entrega.taxaCalculadaId,
      hash: this.entrega.hash,
      adicionais: this.adicionais,
      valoresAdicionais: this.valoresAdicionais,
      total: this.total,
      origem: this.origem,
      tabelasDePrecosAplicadas: this.tabelasDePrecosAplicadas,
      op: localStorage.getItem('operador')
    }

    if(!this.entrega.ehRetirada())
      dados.endereco =  this.entrega.endereco;

    let valorPagar =  this.obtenhaValorAhPagar();

    if(valorPagar > 0){
      if(this.pagamento && this.pagamento.formaDePagamento){
        dados.pagamentos.push(Object.assign({}, this.pagamento))
        dados.pagamentos[0].valor = valorPagar;
      }
    }

    if(this.cashback && this.cashback.valor){
      let dadosPagamento: any = {
        valor: this.cashback.valor,
        cartao: this.cashback.cartao,
        formaDePagamento:  empresa.formasDePagamento.find( forma => forma.nome === 'cashback' )
      }

      if(this.cashback.cashbackExterno)
        dadosPagamento.cashbackExterno = this.cashback.cashbackExterno;

      dados.pagamentos.push(dadosPagamento);
    }

    if(this.resgate && this.resgate.valor){
      let dadosPagamento: any = {
        valor: this.resgate.valor,
        formaDePagamento:  empresa.formasDePagamento.find( forma => forma.nome === 'resgate' )
      }

      for (let i = 0; i < this.itens.length; i++){
        let item: any = this.itens[i];

        if(item.brinde){
          item.cartao = { id: this.resgate.cartaoid}
          item.brinde = { id: item.produto.id};
        }
      }

      dados.pagamentos.push(dadosPagamento);
    }

    if(this.fidelidadeGcom){
      this.contato.adicionarFidelidadeGcom = true;
      this.contato.idCliente = this.fidelidadeGcom.id_cliente;
    }

    if(this.idComanda) dados.idComanda = this.idComanda;
    if(this.idCartaoCliente) dados.idCartaoCliente = this.idCartaoCliente;

    return dados;
  }

  private atualizeTabelasDePrecosAplicadas() {
    this.tabelasDePrecosAplicadas = this.obtenhaIdsTabelasDePrecosAplicadas();
  }

  private obtenhaIdsTabelasDePrecosAplicadas(): number[] {
    const ids = new Set<number>();
    (this.itens || []).forEach((item: any) => this.coleteIdsTabelasDePrecos(item, ids));
    return Array.from(ids);
  }

  private coleteIdsTabelasDePrecos(alvo: any, ids: Set<number>, profundidade = 0) {
    if(!alvo || profundidade > 5)
      return;

    if(Array.isArray(alvo)) {
      alvo.forEach((item: any) => this.coleteIdsTabelasDePrecos(item, ids, profundidade + 1));
      return;
    }

    if(typeof alvo !== 'object')
      return;

    this.adicioneIdTabelaPreco(ids, alvo.tabelaDePrecosAplicada);
    this.adicioneIdTabelaPreco(ids, alvo.tabelaPrecoAtacado);
    (alvo.idsTabelasDePrecosAplicadas || []).forEach((id: any) => this.adicioneIdTabelaPreco(ids, id));

    ['produto', 'produtoTamanho', 'sabores', 'adicionais', 'opcoes', 'opcoesDisponiveis'].forEach((prop: string) => {
      this.coleteIdsTabelasDePrecos(alvo[prop], ids, profundidade + 1);
    });

    Object.keys(alvo).forEach((prop: string) => {
      if(prop.startsWith('campo') || prop.startsWith('lista'))
        this.coleteIdsTabelasDePrecos(alvo[prop], ids, profundidade + 1);
    });
  }

  private adicioneIdTabelaPreco(ids: Set<number>, tabela: any) {
    const id = Number(tabela?.id || tabela);
    if(id && !isNaN(id))
      ids.add(id);
  }

  informouFormaDePagamento(): boolean {
    return (this.pagamento && this.pagamento.formaDePagamento != null) || (this.cashback && this.cashback.valor === this.total) ||
      (this.resgate && this.total === 0 &&  this.totalResgatado === this.resgate.valor);
  }

  informouFormaDeEntrega(): boolean{
    return this.entrega && this.entrega.formaDeEntrega != null;
  }

  setNovoPagamento(){
    this.pagamento = new Pagamento();
  }

  temValorMinimoDaFormaEscolhida(formasDeEntrega: any){
    if(! this.entrega || !this.entrega.formaDeEntrega) return true;

    return this.temValorMinimo(this.entrega.formaDeEntrega, formasDeEntrega)
  }

  obtenhaValorMinimoDaFormaEscolhida(  formasDeEntrega: any){
    if(! this.entrega || !this.entrega.formaDeEntrega) return true;

    return this.obtenhaValorMinimoParaEntrega(this.entrega.formaDeEntrega, formasDeEntrega)
  }


  obtenhaFormaEscolhida( formasDeEntrega: any, nomeForma: string = this.entrega.formaDeEntrega){
    if(!formasDeEntrega) return null;

    //todo: :( gambi, hoje salva string a forma, retirar quando mudar para salvar obj
    if(nomeForma === FormaDeEntrega.COMERNOLOCAL)
      nomeForma = FormaDeEntrega.RETIRAR;

    return formasDeEntrega.find( (forma: any) => forma.nome ===  nomeForma );

  }

  obtenhaLabelFormaSelecionada(){
    if(!this.entrega.formaDeEntrega) return '';

    if(this.entrega.formaDeEntrega === FormaDeEntrega.RECEBER_EM_CASA)
      return 'entrega'

    return 'retirada';
  }

  temValorMinimo(nomeForma: any, formasDeEntrega: any) {
    let formaDeEntrega = this.obtenhaFormaEscolhida(formasDeEntrega, nomeForma);

    if(formaDeEntrega && formaDeEntrega.valorMinimoPedido){
      return this.obtenhaSubTotal() >= formaDeEntrega.valorMinimoPedido;
    } else {
      return true;
    }
  }


  obtenhaValorMinimoParaEntrega(nomeForma: any, formasDeEntrega: any){
    let formaDeEntrega = this.obtenhaFormaEscolhida(formasDeEntrega, nomeForma);

    if(formaDeEntrega && formaDeEntrega.valorMinimoPedido){
      return  formaDeEntrega.valorMinimoPedido;
    } else {
      return  0;
    }
  }

  ultrapassouValorMaximo(nomeForma: any, formasDeEntrega: any){
    let formaDeEntrega = this.obtenhaFormaEscolhida(formasDeEntrega, nomeForma);

    if(formaDeEntrega && formaDeEntrega.valorMaximoPedido){
      return this.obtenhaValorParaValidacaoFormaEntrega(formasDeEntrega) > formaDeEntrega.valorMaximoPedido;
    } else {
      return false;
    }
  }

  ultrapassouValorMaximoDaFormaEscolhida(formasDeEntrega: any){
    if(!this.entrega || !this.entrega.formaDeEntrega) return false;

    return this.ultrapassouValorMaximo(this.entrega.formaDeEntrega, formasDeEntrega)
  }


  obtenhaValorMaximoParaEntrega(nomeForma: any, formasDeEntrega: any){
    let formaDeEntrega = this.obtenhaFormaEscolhida(formasDeEntrega, nomeForma);

    if(formaDeEntrega && formaDeEntrega.valorMaximoPedido){
      return  formaDeEntrega.valorMaximoPedido;
    } else {
      return  0;
    }
  }

  obtenhaValorMaximoDaFormaEscolhida( formasDeEntrega: any){
    if(! this.entrega || !this.entrega.formaDeEntrega) return 0;

    return this.obtenhaValorMaximoParaEntrega(this.entrega.formaDeEntrega, formasDeEntrega)
  }


  permiteAgendamento(nomeForma: any, formasDeEntrega: any) {
   let formaDeEntrega = this.obtenhaFormaEscolhida(formasDeEntrega, nomeForma);

    return formaDeEntrega ? formaDeEntrega.permiteAgendamento : false;
  }

  obtenhaIntervaloAgendamento(nomeForma: any, formasDeEntrega: any) {
    let formaDeEntrega = this.obtenhaFormaEscolhida(formasDeEntrega, nomeForma);
    return formaDeEntrega ? formaDeEntrega.intervaloAgendamento : false
  }

  naoInformarHorarioNoAgendamento(nomeForma: any, formasDeEntrega: any) {
    if(formasDeEntrega) {
      let formaDeEntrega = formasDeEntrega.find( (forma: any) => forma.nome ===  nomeForma );

      if(!formaDeEntrega) return false;

      return formaDeEntrega.naoPerguntarHorario;
    }
  }

  naoInformarHorarioNoAgendamentoSelecionado(formasDeEntrega: any){
    return this.naoInformarHorarioNoAgendamento(this.entrega.formaDeEntrega, formasDeEntrega)
  }

  private obtenhaHorarioEntregaAgendada(empresa: any): Date {
    if(!this.dataEntrega) return null;

    const naoInformarHorario = this.naoInformarHorarioNoAgendamentoSelecionado(empresa.formasDeEntrega);
    if(!naoInformarHorario && !this.horarioEntrega) return null;

    let horarioAgendamento = new Date(this.dataEntrega.toDateString())

    if( this.horarioEntrega ) {
      horarioAgendamento.setHours(parseInt(this.horarioEntrega.split(':')[0], 10))
      horarioAgendamento.setMinutes(parseInt(this.horarioEntrega.split(':')[1], 10))
    }

    return horarioAgendamento

  }

  naoInformouAgendamento(formasDeEntrega: any){
    let naoInformouHorario =
      this.naoInformarHorarioNoAgendamentoSelecionado(formasDeEntrega) ? false : !this.horarioEntrega


    return !this.dataEntrega || naoInformouHorario
  }

  obtenhaMensagemAgendamentoPendente(formasDeEntrega: any): string {
    const naoInformarHorario = this.naoInformarHorarioNoAgendamentoSelecionado(formasDeEntrega);

    if(!this.dataEntrega) {
      return naoInformarHorario ?
        'É necessário escolher o dia da entrega' :
        'É necessário escolher o dia e horário da entrega';
    }

    if(!naoInformarHorario && !this.horarioEntrega)
      return 'É necessário escolher o horário da entrega';

    return '';
  }

  apliqueCupom(dados: any) {
    if(dados && dados.desconto >= 0) {
      this.cupom = new CupomPedido(dados.id, dados.desconto, dados.codigo, dados.aplicarNaTaxaDeEntrega,
                                   dados.naoPontuarFidelidade, dados.aplicarAuto, dados.cashback, dados.brindeResgate, dados.restrito);

      if(dados.erro)
        this.cupom.erro = dados.erro;

      this.desconto += this.cupom.desconto;
      this.limpeTroco();
      this.calculeTotal();
    }
  }


  apliqueDescontoPromocional(respostaDescontos: any) {
    this.promocoesAplicadas = []
    if(respostaDescontos && respostaDescontos.desconto >= 0) {
      for(let promocaoAplicada of respostaDescontos.promocoesAplicadas) {
        let descontoPromocional = new DescontoPromocional(promocaoAplicada.id, promocaoAplicada.empresa, promocaoAplicada.descricao,
          promocaoAplicada.desconto, promocaoAplicada.cumulativa, promocaoAplicada.produtosAdicionados)

        if(promocaoAplicada.produtosRemovidos) {
          for(let produtoRemovido of promocaoAplicada.produtosRemovidos)
            this.removaItem(this.getItem(produtoRemovido))
        }


        this.promocoesAplicadas.push(descontoPromocional)
        console.log(descontoPromocional)
        this.desconto += descontoPromocional.desconto

        if(descontoPromocional.produtosAdicionados)
          for(let produtoAdicionado of descontoPromocional.produtosAdicionados)
            this.adicione(produtoAdicionado.produto, 1, produtoAdicionado.observacao, null, null, null)



      }
      this.calculeTotal();
    }

  }


  removaCupom() {
    delete this.codigoCupom
    delete this.cupom;
    this.desconto = 0;
    this.calculeTotal();
  }

  obtenhaDescricaoPagamento() {
    if(!this.pagamento || !this.pagamento.formaDePagamento ) {
      if(this.usandoCashbackNoPagamento())  return 'Fidelidade Cashback'

      if(this.resgatandoBrinde()) return 'Pontos Fidelidade'

      return ''
    }

    let descricao =   this.pagamento.formaDePagamento.descricao

    if(this.pagamento.dadosCartao && this.pagamento.dadosCartao.descricaoPagamento)
      descricao = this.pagamento.dadosCartao.descricaoPagamento
    else if(this.pagamento.formaDePagamento.carteiraDigital)
      descricao = this.pagamento.formaDePagamento.carteiraDigital

    if(this.usandoCashbackNoPagamento())  descricao = String(`Cashback + ${descricao}`)
    else if(this.resgatandoBrinde())
       descricao = String(`Pontos + ${descricao}`)

    return descricao;
  }

  ehDeMultiloja() {
    return this.origem === 'multiloja';
  }

  obtenhaQtdeItens(itemPedido: any){
    let qtde = 0

    for(let item of this.itens)
      if(itemPedido && itemPedido.guid !== item.guid)
         qtde += item.qtde;

    return qtde;
  }

  usandoCashbackNoPagamento() {
    return this.cashback && this.cashback.valor;
  }

  resgatandoBrinde(){
    return this.resgate && this.resgate.valor
  }

  resgatandoBrindeOuUsandoCashback(){
    return this.usandoCashbackNoPagamento() || this.resgatandoBrinde();
  }

  maisDeUmaFormaPagamento(){
    return this.pagamento && this.pagamento.formaDePagamento && this.resgatandoBrindeOuUsandoCashback();
  }

  autenticouCartaoOnline() {
    if(!this.pagamento) return false;

    try{
      if(!this.pagamento.cartaoCreditoOnline()) return false;

      return this.pagamento.dadosCartao && ( this.pagamento.dadosCartao.autenticacao3ds ||
        this.pagamento.dadosCartao.autenticouCarteiraDigital);
    } catch (err){
      console.error(err)
      return false;
    }
  }



  validarValorPedido(){
    return this.autenticouCartaoOnline() && this.pagamento.dadosCartao.valorPagamento;
  }


  temProdutoIndisponivelNoDia(date: Date, catalogo: any) {
    let resposta = false;

    try{
      const diaDaSemana = date.getDay();
      const dataMoment = moment(date);
      this.itens.forEach((itemPedido: any) => {
        //todo: restar mudan disp no produto para sempre ver vem preenchido
        if(itemPedido.produto && itemPedido.produto.disponibilidades?.length){
          let produtoDisponivel = false;
          //console.log('verificando produto dispononivel no dia: ', diaDaSemana )
          for(let dip of itemPedido.produto.disponibilidades){
            let disponibilidade = catalogo.disponibilidades.find((item: any) => item.id === dip.id)

            if(disponibilidade && !produtoDisponivel){

              const dataInicioValida = disponibilidade.dataInicio ?
                dataMoment.isSameOrAfter(moment(disponibilidade.dataInicio), 'day') : true;

              const dataFimValida = disponibilidade.dataFim ? dataMoment.isSameOrBefore(moment(disponibilidade.dataFim), 'day') : true;

              if(dataInicioValida && dataFimValida){
                if( disponibilidade.periodos?.length){
                  let periodosNoDia = disponibilidade.periodos.find((periodo: any) => {
                    let turnoDisponivel: any =
                      periodo.dias.find( (dInfo: any) => dInfo.dia === diaDaSemana  ) ;

                    return turnoDisponivel != null;
                  })

                  if(periodosNoDia) produtoDisponivel = true;
                } else {
                  produtoDisponivel = true;
                }
              }
            }
          }
          //console.log('produto nao disponivel no dia: ' + produtoDispnivel)
          if(!produtoDisponivel)
            resposta = true;
        }
      })

    } catch (err){
      console.error(err)
    } finally {
      return resposta;
    }
  }

  temProdutoIndisponivelNaDataHora(dateTime: Date, catalogo: any) {
    let resposta = false;

    try{
      const diaDaSemana = dateTime.getDay();
      const dataMoment = moment(dateTime);

      const horasMinutos = Number(dataMoment.format('HHmm'));

      const horaPeriodoToNumero = (valor: any) => {
        if(!valor) return null;
        if(valor instanceof Date) {
          const hh = String(valor.getHours()).padStart(2, '0');
          const mm = String(valor.getMinutes()).padStart(2, '0');
          return Number(`${hh}${mm}`);
        }
        const txt = String(valor);
        // suporta "HH:mm" e "HH:mm:ss"
        return Number(txt.substr(0, 5).replace(/\D/g, ''));
      };

      this.itens.forEach((itemPedido: any) => {
        if(itemPedido.produto && itemPedido.produto.disponibilidades?.length){
          let produtoDisponivel = false;

          for(let dip of itemPedido.produto.disponibilidades){
            let disponibilidade = catalogo.disponibilidades.find((item: any) => item.id === dip.id)

            if(disponibilidade && !produtoDisponivel){
              const dataInicioValida = disponibilidade.dataInicio ?
                dataMoment.isSameOrAfter(moment(disponibilidade.dataInicio), 'day') : true;

              const dataFimValida = disponibilidade.dataFim ? dataMoment.isSameOrBefore(moment(disponibilidade.dataFim), 'day') : true;

              if(dataInicioValida && dataFimValida){
                // sem períodos: assume disponível todos os dias (24h)
                if(!disponibilidade.periodos || !disponibilidade.periodos.length){
                  produtoDisponivel = true;
                } else {
                  // com períodos: precisa existir um período com o dia e (se informado) dentro do intervalo de horas
                  let periodosNoHorario = disponibilidade.periodos.find((periodo: any) => {
                    let turnoDisponivel: any = periodo.dias?.find((dInfo: any) => dInfo.dia === diaDaSemana);
                    if(!turnoDisponivel) return false;

                    if(!periodo.horaInicio || !periodo.horaFim) return true;

                    const hi = horaPeriodoToNumero(periodo.horaInicio);
                    const hf = horaPeriodoToNumero(periodo.horaFim);
                    if(hi == null || hf == null) return true;

                    return hi <= horasMinutos && horasMinutos <= hf;
                  })

                  if(periodosNoHorario) produtoDisponivel = true;
                }
              }
            }
          }

          if(!produtoDisponivel)
            resposta = true;
        }
      })

    } catch (err){
      console.error(err)
    } finally {
      return resposta;
    }
  }
}
